import { CONSORS_ACADEMIC_TITLES } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsAcademicTitle = z.nativeEnum(CONSORS_ACADEMIC_TITLES);
export type SchemaConsorsAcademicTitle = z.infer<typeof schemaConsorsAcademicTitle>;
